import {
  getAccountsDashboardService,
  getAccountsListService,
  getContactsListService,
} from 'modules/Services/AnalyticsService';
import {
  ANALYTICS_ACCOUNTS_DASHBOARD,
  ANALYTICS_ACCOUNTS_DATA,
  ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS,
  ANALYTICS_DATA_EXPORT,
  ANALYTICS_INTENT_DATA,
} from 'constants/types';
import store from 'store';
import { setFirstTimeAllDataShown } from '../Dashboard/actions';

export const getPaginatedAccountsData = (params: any, callback?: any) => {
  if (params !== undefined) {
    if (!params.exportAnalytics)
      store.dispatch({
        type: params.offset === 0 ? ANALYTICS_ACCOUNTS_DATA.LOAD : ANALYTICS_ACCOUNTS_DATA.LOAD_MORE,
      });

    store.dispatch({
      type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
      payload: true,
    });

    const firstTimeFilterShown = store.getState().analyticsDashboard.firstAllDataShown;

    getAccountsListService(params)
      .then((response) => {
        if (params.exportAnalytics) {
          store.dispatch({
            type: ANALYTICS_DATA_EXPORT.SET_OPEN,
            payload: response.data.email_address,
          });
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: false,
          });
        } else {
          store.dispatch({
            type:
              params.offset === 0 ? ANALYTICS_ACCOUNTS_DATA.LOAD_SUCCESS : ANALYTICS_ACCOUNTS_DATA.LOAD_MORE_SUCCESS,
            payload: {
              ...response.data,
              result: response.data.result.map((account: any) => ({
                ...account,
                queryParam: `/analytics/accounts/dashboard?account_id=${account?.company_id}`,
              })),
            },
          });
          if (response.data.total_accounts) {
            store.dispatch({
              type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
              payload: response.data.total_records > 0 ? false : params.offset > 0 ? false : true,
            });
          } else {
            let accountsLength = store.getState().analyticsAccounts.data.length;
            if (accountsLength > 0) {
              store.dispatch({
                type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
                payload: false,
              });
            }
          }
          if (!firstTimeFilterShown) {
            setFirstTimeAllDataShown(true);
          }
        }
        store.dispatch({
          type: ANALYTICS_ACCOUNTS_DATA.FILTER_RESET,
          payload: false,
        });
        store.dispatch({
          type: ANALYTICS_ACCOUNTS_DATA.SEARCH_RESET,
          payload: params.searchWord !== '' ? true : false,
        });
        if (callback)
          setTimeout(() => {
            callback(false);
          }, 500);
      })
      .catch((err) => {
        console.error(err);
        if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
          store.dispatch({
            type: ANALYTICS_ACCOUNTS_DATA.LOAD_FAIL,
          });
        }
        let accounts = store.getState().analyticsAccounts.data;
        if (accounts.length > 0) {
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: false,
          });
        } else {
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: true,
          });
        }
      });
  }
};

export const resetFilterbyAccounts = () => {
  store.dispatch({ type: ANALYTICS_ACCOUNTS_DATA.SET_ACCOUNTS_BY_FILTER, payload: '' });
};

//Fetch accounts dashboard listing
export const getAccountsDetails = (params: any, contactsOnly = false) => {
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DASHBOARD.LOAD_STATS,
    payload: contactsOnly,
  });
  getAccountsDashboardService(params)
    .then((response) => {
      if (response.status === 200) {
        store.dispatch({
          type: ANALYTICS_ACCOUNTS_DASHBOARD.DATA,
          payload: {
            data: response.data,
          },
        });
        store.dispatch({
          type: ANALYTICS_ACCOUNTS_DASHBOARD.SHOW_ENTITIES_COUNT,
          payload: {
            campaign_count: response.data.campaign_count,
            email_count: response.data.email_count,
          },
        });
        store.dispatch({
          type: ANALYTICS_ACCOUNTS_DATA.SELECTED_ACCOUNT,
          payload: { selectedAccount: response.data.company_name },
        });
      } else {
        store.dispatch({
          type: ANALYTICS_ACCOUNTS_DASHBOARD.LOAD_STATS_FAIL,
        });
      }
    })
    .catch((err) => {
      console.log('account dashboard Error: ', err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ANALYTICS_ACCOUNTS_DASHBOARD.LOAD_FAIL,
        });
      }
    });
};
export const getAccountsDashboard = (params: any = {}, isAccounts?: boolean, callback?: any) => {
  if (!params.exportAnalytics)
    store.dispatch({
      type: ANALYTICS_ACCOUNTS_DASHBOARD.LOAD,
      payload: params.contactsOnly,
    });
  if (params.contactsOnly) {
  }
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  getContactsListService(params, isAccounts)
    .then((response) => {
      if (response.status === 200) {
        if (params.exportAnalytics) {
          store.dispatch({
            type: ANALYTICS_DATA_EXPORT.SET_OPEN,
            payload: response.data.email_address,
          });
          store.dispatch({
            type: ANALYTICS_ACCOUNTS_DASHBOARD.LOAD_FAIL,
          });
        } else {
          store.dispatch({
            type: ANALYTICS_ACCOUNTS_DASHBOARD.LOAD_SUCCESS,
            payload: {
              data: {
                account_contacts: response.data.delivered.map((item: any) => ({
                  ...item,
                  queryParam: `/analytics/contacts/dashboard/?contact_id=${item?.contact_id}`,
                })),
              },
              total_records: response.data.total_delivered,
            },
          });
        }
        if (callback)
          setTimeout(() => {
            callback(false);
          }, 500);
        if (response?.data?.total_delivered) {
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: response.data.total_delivered > 0 ? false : true,
          });
        } else {
          let contactsCount = store.getState().accountsDashboard?.data?.account_contacts?.length;
          if (contactsCount !== undefined && contactsCount > -1)
            store.dispatch({
              type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
              payload: contactsCount > 0 ? false : true,
            });
        }
      } else {
        store.dispatch({
          type: ANALYTICS_ACCOUNTS_DASHBOARD.LOAD_FAIL,
        });
      }
    })
    .catch((err) => {
      console.log('account dashboard Error: ', err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ANALYTICS_ACCOUNTS_DASHBOARD.LOAD_FAIL,
        });
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
          payload: true,
        });
      }
    });
};

export const setCampaignAndEmailIdsForDashboard = (selectedFilters: any) => {
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DASHBOARD.SET_SELECTED_CAMPAIGNS,
    payload: {
      campaignIds: selectedFilters.campaignIds,
    },
  });
  store.dispatch({
    type: ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.SET_SELECTED_CAMPAIGNS,
    payload: {
      campaignIds: selectedFilters.campaignIds,
    },
  });
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DASHBOARD.SET_SELECTED_EMAILS,
    payload: {
      emailIds: selectedFilters.emailIds,
    },
  });
  store.dispatch({
    type: ACCOUNTS_CONTENT_ENGAGEMENT_ANALYTICS.SET_SELECTED_EMAILS,
    payload: {
      emailIds: selectedFilters.emailIds,
    },
  });
};

export const resetAccountDashboard = (flag: boolean) => {
  store.dispatch({ type: ANALYTICS_ACCOUNTS_DASHBOARD.RESET, payload: flag });
};
